export const useListen = (controller) => {
  const controllerDisconnect = controller.disconnect.bind(controller);
  controller.eventTarget ??= new EventTarget();

  const listen = (eventName, callback, target = controller.eventTarget) => {
    // This allows passing a controller as the target
    if (target?.eventTarget !== undefined) target = target.eventTarget;
    const boundCallback = (evt) =>
      callback.bind(controller)(evt?.detail || evt);
    target.addEventListener(eventName, boundCallback);
    controller._removeListeners ??= [];
    controller._removeListeners.push(() =>
      target.removeEventListener(eventName, boundCallback),
    );
  };

  // listenRaw skips the evt.detail unwrap and hands the event itself to
  // the callback. Use for native DOM events (click, mouseover, etc.) where
  // evt.detail is meaningful in its own right (click count, etc.) and
  // listen() would clobber the event with that number.
  const listenRaw = (eventName, callback, target = controller.eventTarget) => {
    if (target?.eventTarget !== undefined) target = target.eventTarget;
    const boundCallback = callback.bind(controller);
    target.addEventListener(eventName, boundCallback);
    controller._removeListeners ??= [];
    controller._removeListeners.push(() =>
      target.removeEventListener(eventName, boundCallback),
    );
  };

  const listenWindow = (eventName, callback) => {
    listen(eventName, callback, window);
  };

  const emit = (eventName, detail = {}, target = controller.eventTarget) => {
    target.dispatchEvent(new CustomEvent(eventName, { detail }));
  };

  const emitWindow = (eventName, detail = {}) => {
    emit(eventName, detail, window);
  };

  const disconnect = () => {
    if (controller._removeListeners) {
      controller._removeListeners.forEach((remove) => remove());
      controller._removeListeners = [];
    }
  };

  Object.assign(controller, {
    listen,
    listenRaw,
    listenWindow,
    emit,
    emitWindow,
    disconnect() {
      disconnect();
      controllerDisconnect();
    },
  });
};
